var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.137695,
    y: 0.510254,
    width: 58.5498,
    height: 57.4178,
    rx: 5,
    fill: "#E2574C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.665 36.8147V21.9889H16.1506C17.3366 21.9889 18.3179 22.1866 19.0945 22.582C19.8711 22.9773 20.45 23.5209 20.8313 24.2128C21.2125 24.9047 21.4031 25.6812 21.4031 26.5425C21.4031 27.3615 21.2196 28.1169 20.8524 28.8088C20.4853 29.4865 19.9135 30.0372 19.1369 30.4608C18.3603 30.8702 17.3649 31.075 16.1506 31.075H13.376V36.8147H10.665ZM13.376 28.8723H15.9811C16.9271 28.8723 17.6049 28.6676 18.0144 28.2581C18.438 27.8345 18.6498 27.2626 18.6498 26.5425C18.6498 25.8083 18.438 25.2365 18.0144 24.827C17.6049 24.4034 16.9271 24.1916 15.9811 24.1916H13.376V28.8723Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.53 36.8147V21.9889H28.5919C30.3287 21.9889 31.7548 22.2996 32.8702 22.9208C33.9998 23.528 34.8329 24.3893 35.3694 25.5047C35.9201 26.6061 36.1954 27.9051 36.1954 29.4018C36.1954 30.8985 35.9201 32.2046 35.3694 33.32C34.8329 34.4214 33.9998 35.2827 32.8702 35.9039C31.7548 36.5111 30.3287 36.8147 28.5919 36.8147H23.53ZM26.241 34.4849H28.4649C29.7074 34.4849 30.6887 34.2872 31.4088 33.8919C32.1289 33.4824 32.6443 32.9035 32.9549 32.1551C33.2656 31.3927 33.4209 30.4749 33.4209 29.4018C33.4209 28.3428 33.2656 27.4321 32.9549 26.6696C32.6443 25.9072 32.1289 25.3212 31.4088 24.9117C30.6887 24.5022 29.7074 24.2975 28.4649 24.2975H26.241V34.4849Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5874 36.8147V21.9889H48.1606V24.1704H41.2984V28.3216H46.8474V30.4608H41.2984V36.8147H38.5874Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c389d777bcb6e1afa799bba3fa043b0d.svg";
export { ForwardRef as ReactComponent };